var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(87.843137%,13.72549%,5.098039%)",
      fillOpacity: 1
    },
    d: "M 23.25 0.9375 L 23.25 49.3125 C 26.011719 49.3125 28.25 47.074219 28.25 44.3125 L 28.25 5.9375 C 28.25 3.175781 26.011719 0.9375 23.25 0.9375 Z M 23.25 0.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,32.941176%,25.098039%)",
      fillOpacity: 1
    },
    d: "M 23.25 0.9375 C 23.941406 0.9375 24.5 3.175781 24.5 5.9375 L 24.5 44.3125 C 24.5 47.074219 23.941406 49.3125 23.25 49.3125 C 20.488281 49.3125 18.25 47.074219 18.25 44.3125 L 18.25 5.9375 C 18.25 3.175781 20.488281 0.9375 23.25 0.9375 Z M 23.25 0.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(87.843137%,13.72549%,5.098039%)",
      fillOpacity: 1
    },
    d: "M 23.25 53.0625 L 23.25 63.0625 C 26.011719 63.0625 28.25 60.824219 28.25 58.0625 C 28.25 55.300781 26.011719 53.0625 23.25 53.0625 Z M 23.25 53.0625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,32.941176%,25.098039%)",
      fillOpacity: 1
    },
    d: "M 23.25 53.0625 C 23.941406 53.0625 24.5 55.300781 24.5 58.0625 C 24.5 60.824219 23.941406 63.0625 23.25 63.0625 C 20.488281 63.0625 18.25 60.824219 18.25 58.0625 C 18.25 55.300781 20.488281 53.0625 23.25 53.0625 Z M 23.25 53.0625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(87.843137%,13.72549%,5.098039%)",
      fillOpacity: 1
    },
    d: "M 40.75 0.9375 L 40.75 49.3125 C 43.511719 49.3125 45.75 47.074219 45.75 44.3125 L 45.75 5.9375 C 45.75 3.175781 43.511719 0.9375 40.75 0.9375 Z M 40.75 0.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,32.941176%,25.098039%)",
      fillOpacity: 1
    },
    d: "M 40.75 0.9375 C 41.441406 0.9375 42 3.175781 42 5.9375 L 42 44.3125 C 42 47.074219 41.441406 49.3125 40.75 49.3125 C 37.988281 49.3125 35.75 47.074219 35.75 44.3125 L 35.75 5.9375 C 35.75 3.175781 37.988281 0.9375 40.75 0.9375 Z M 40.75 0.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(87.843137%,13.72549%,5.098039%)",
      fillOpacity: 1
    },
    d: "M 40.75 53.0625 L 40.75 63.0625 C 43.511719 63.0625 45.75 60.824219 45.75 58.0625 C 45.75 55.300781 43.511719 53.0625 40.75 53.0625 Z M 40.75 53.0625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,32.941176%,25.098039%)",
      fillOpacity: 1
    },
    d: "M 40.75 53.0625 C 41.441406 53.0625 42 55.300781 42 58.0625 C 42 60.824219 41.441406 63.0625 40.75 63.0625 C 37.988281 63.0625 35.75 60.824219 35.75 58.0625 C 35.75 55.300781 37.988281 53.0625 40.75 53.0625 Z M 40.75 53.0625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 23.25 0 C 19.976562 0 17.3125 2.664062 17.3125 5.9375 L 17.3125 23.25 C 17.3125 23.769531 17.730469 24.1875 18.25 24.1875 C 18.769531 24.1875 19.1875 23.769531 19.1875 23.25 L 19.1875 5.9375 C 19.1875 3.699219 21.011719 1.875 23.25 1.875 C 25.488281 1.875 27.3125 3.699219 27.3125 5.9375 L 27.3125 44.3125 C 27.3125 46.550781 25.488281 48.375 23.25 48.375 C 21.011719 48.375 19.1875 46.550781 19.1875 44.3125 L 19.1875 27 C 19.1875 26.480469 18.769531 26.0625 18.25 26.0625 C 17.730469 26.0625 17.3125 26.480469 17.3125 27 L 17.3125 44.3125 C 17.3125 47.585938 19.976562 50.25 23.25 50.25 C 26.523438 50.25 29.1875 47.585938 29.1875 44.3125 L 29.1875 5.9375 C 29.1875 2.664062 26.523438 0 23.25 0 Z M 23.25 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 23.25 52.125 C 19.976562 52.125 17.3125 54.789062 17.3125 58.0625 C 17.3125 61.335938 19.976562 64 23.25 64 C 26.523438 64 29.1875 61.335938 29.1875 58.0625 C 29.1875 54.789062 26.523438 52.125 23.25 52.125 Z M 23.25 62.125 C 21.011719 62.125 19.1875 60.300781 19.1875 58.0625 C 19.1875 55.824219 21.011719 54 23.25 54 C 25.488281 54 27.3125 55.824219 27.3125 58.0625 C 27.3125 60.300781 25.488281 62.125 23.25 62.125 Z M 23.25 62.125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 40.75 0 C 37.476562 0 34.8125 2.664062 34.8125 5.9375 L 34.8125 23.25 C 34.8125 23.769531 35.230469 24.1875 35.75 24.1875 C 36.269531 24.1875 36.6875 23.769531 36.6875 23.25 L 36.6875 5.9375 C 36.6875 3.699219 38.511719 1.875 40.75 1.875 C 42.988281 1.875 44.8125 3.699219 44.8125 5.9375 L 44.8125 44.3125 C 44.8125 46.550781 42.988281 48.375 40.75 48.375 C 38.511719 48.375 36.6875 46.550781 36.6875 44.3125 L 36.6875 27 C 36.6875 26.480469 36.269531 26.0625 35.75 26.0625 C 35.230469 26.0625 34.8125 26.480469 34.8125 27 L 34.8125 44.3125 C 34.8125 47.585938 37.476562 50.25 40.75 50.25 C 44.023438 50.25 46.6875 47.585938 46.6875 44.3125 L 46.6875 5.9375 C 46.6875 2.664062 44.023438 0 40.75 0 Z M 40.75 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 40.75 52.125 C 37.476562 52.125 34.8125 54.789062 34.8125 58.0625 C 34.8125 61.335938 37.476562 64 40.75 64 C 44.023438 64 46.6875 61.335938 46.6875 58.0625 C 46.6875 54.789062 44.023438 52.125 40.75 52.125 Z M 40.75 62.125 C 38.511719 62.125 36.6875 60.300781 36.6875 58.0625 C 36.6875 55.824219 38.511719 54 40.75 54 C 42.988281 54 44.8125 55.824219 44.8125 58.0625 C 44.8125 60.300781 42.988281 62.125 40.75 62.125 Z M 40.75 62.125 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.a2dd2ac40d7b658b1c985a0a0a64eaa2.svg";
export { ForwardRef as ReactComponent };